// extracted by mini-css-extract-plugin
module.exports = {"headerColumn":"feedteststyle_headerColumn__6DXZ7","rowColumn":"feedteststyle_rowColumn__19uDH"};